import { apiClient } from '../../utils';
import { handleError } from '../';

export const removeMenu = async ({ siteId, menuId }) => {
  try {
    const { result } = await apiClient.post('/merchant/menu/deleteItem', {
      data: { siteID: siteId, itemID: menuId },
    });
    return result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
